import { useState } from "react";
import { Control, useWatch } from "react-hook-form";
import { ModuSignStartDocumentRequest } from "src/api/contract/modusign-types";
import { BaseButton, BaseInput } from "src/components";
import { checkValidateOrgNumber, companyRegistrationHypen } from "src/utils";

type Props = {
  control: Control<ModuSignStartDocumentRequest>;
  verifyIdx: number;
  onClose: () => void;
  setValueVerification: (verification: { name: string; bizNumber: string }) => void;
};

const ModuSignDCertVerify = ({ control, verifyIdx, onClose, setValueVerification }: Props) => {
  const verificationValue = useWatch({
    control,
    name: `document.participantMappingsList.${verifyIdx}.verification.dCert`,
  });

  const [verification, setVerification] = useState({
    name: verificationValue?.name || "",
    bizNumber: verificationValue?.bizNumber || "",
  });

  const [error, setError] = useState({
    nameError: "",
    bizNumberError: "",
  });

  // 기존 Controller rules를 그대로 옮긴 검증 함수들
  const validateName = (value: string): string => {
    if (!value) {
      return "이름을 입력해주세요.";
    }

    return "";
  };

  const validateBizNumber = (value: string): string => {
    if (!value) {
      return "사업자 등록번호를 입력해주세요.";
    }

    if (!checkValidateOrgNumber(String(value))) {
      return "올바르지 않은 등록 번호입니다.";
    }

    return "";
  };

  // 모든 필드 검증
  const validateAll = (): boolean => {
    const nameError = validateName(verification.name);
    const bizNumberError = validateBizNumber(verification.bizNumber);

    setError({
      nameError,
      bizNumberError,
    });

    return !nameError && !bizNumberError;
  };

  const handleSubmit = () => {
    const isValid = validateAll();
    if (isValid) {
      setValueVerification(verification);
      onClose();
    }
  };

  return (
    <>
      <section className="base-abstract-modal__title">
        <h1>받는 사람의 법인 공동 인증서 추가</h1>
      </section>
      <section className="base-abstract-modal__contents mx30">
        <ul className="base-list">
          <li>받는 사람의 법인 공동 인증서 인증이 추가됩니다.</li>
        </ul>
        <div className="contents-container mt20">
          <section className="contents-container__grid mb10">
            <div className="contents-container__grid-index">
              <p className="required">이름</p>
            </div>
            <div className="contents-container__grid-contents flex-center-end pl5">
              <BaseInput
                placeholder="이름을 입력해주세요"
                onChange={(value: string) => {
                  setVerification({ ...verification, name: value });

                  if (error.nameError) {
                    setError((prev) => ({ ...prev, nameError: validateName(value) }));
                  } else {
                    setError((prev) => ({ ...prev, nameError: "" }));
                  }
                }}
                value={verification.name}
                name={""}
                errorText={error?.nameError}
              />
            </div>
          </section>
          <section className="contents-container__grid">
            <div className="contents-container__grid-index">
              <p className="required">사업자 등록번호</p>
            </div>
            <div className="contents-container__grid-contents flex-center-end pl5">
              <BaseInput
                maxLength={13}
                placeholder="숫자만 입력해주세요"
                onChange={(text: string) => {
                  setVerification({ ...verification, bizNumber: companyRegistrationHypen(text) });

                  if (error.bizNumberError) {
                    setError((prev) => ({ ...prev, bizNumberError: validateBizNumber(companyRegistrationHypen(text)) }));
                  } else {
                    setError((prev) => ({ ...prev, bizNumberError: "" }));
                  }
                }}
                value={verification.bizNumber}
                name={""}
                errorText={error?.bizNumberError}
              />
            </div>
          </section>
        </div>
      </section>
      <section className="base-abstract-modal__btn-wrap">
        <BaseButton title="닫기" className="color-white" onClick={onClose} />
        <BaseButton title="인증추가" onClick={handleSubmit} />
      </section>
    </>
  );
};

export default ModuSignDCertVerify;
